var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classObj,
    style: ({
      width: _vm.now + '%',
      height: _vm.height
    })
  }, [_vm._v("\n  " + _vm._s(_vm.label ? _vm.now + '%' : '') + "\n")])
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-3a9348c9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a9348c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Progress/n3Progressbar.vue
// module id = 615
// module chunks = 0 1